import adminAPI from "../../api/apiAdmin";

class AdminProductService {
  // GET (single)
  static async get(productId) {
    const res = await adminAPI.get(`/admin/products/${productId}`);
    return res.data;
  }

  // CREATE (supports bulk, images + video)
  static async create(formData) {
    console.log(formData)
    return adminAPI.post("/admin/products", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  // UPDATE
  static async update(productId, formData) {
    return adminAPI.patch(`/admin/products/${productId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  // LIST
  static async list(params = {}) {
    const res = await adminAPI.get("/admin/products", { params });
    return res.data;
  }

  // DELETE (single)
  static async delete(productId) {
    const res = await adminAPI.delete(`/admin/products/${productId}`);
    return res.data;
  }

  // BULK DELETE
  static async bulkDelete(productIds) {
    const res = await adminAPI.delete("/admin/products/bulk-delete", {
      data: { product_ids: productIds },
    });
    return res.data;
  }

  // TOGGLE STATUS
  static async toggleStatus(productId, status) {
    const res = await adminAPI.patch(
      `/admin/products/${productId}/status`,
      { status }
    );
    return res.data.data;
  }

  // TOGGLE POPULAR
  static async togglePopular(productId, isPopular) {
    console.log(isPopular)
    const res = await adminAPI.patch(
      `/admin/products/${productId}/popular`,
      { is_popular: isPopular }
    );
    console.log(res.data.data)
    return res.data.data;
  }
}

export default AdminProductService;
